import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, str2arr, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {FieldworkPageVO, useQueryFieldworkPage} from "@/service/fieldwork.s";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WriteFieldwork} from "@/pages/Fieldwork/WriteFieldwork";
import {Avatar, AvatarGroup} from "@mui/material";
import {ViewFieldwork} from "@/pages/Fieldwork/ViewFieldwork";
import {InvoicePageVO} from "@/service/invoice.s";
import {permScope} from "@/helper/constant";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

export const FieldworkListPage = () => {
    const {
        mutate: fieldworkPageMutate,
        data: fieldworkPageData,
        isPending: fieldworkPagePending,
    } = useQueryFieldworkPage()
    const {role: {dataScope}, id} = useAuthInfo()

    const columns: GridColDef<FieldworkPageVO>[] = [
        {field: "customerName", headerName: "拜访客户", flex: 0.8, minWidth: 150},
        {
            field: "seller",
            headerName: "业务人员",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
            display: "flex",
            valueGetter: (_, row) => ({flag: 1, creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "followers",
            headerName: "随行人员",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            display: "flex",
            renderCell: (({row: {followers}}) => {
                const newFollowers: string[] = str2arr(followers, 'string')
                return <AvatarGroup sx={{
                    '& .MuiAvatarGroup-avatar': {
                        width: 32, height: 32, fontSize: 10, border: 'none'
                    }
                }} max={3}>
                    {newFollowers?.map((owner: string, index: number) => <Avatar key={index} {...stringAvatar(owner)} />)}
                </AvatarGroup>
            })
        },
        {
            field: "address",
            headerName: "拜访地址",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: value => value || "-"
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "travelTime",
            headerName: "出行时间",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
            renderCell: ({row}) => `${formatTime("D", row.startTime)}至${formatTime("D", row.endTime)}`
        },
    ];

    return (
        <ProTable<FieldworkPageVO>
            loading={fieldworkPagePending}
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewFieldwork mode={'drawer'}/>, write: <WriteFieldwork/>}}
            columns={columns}
            data={fieldworkPageData?.data}
            onSearch={(params) => {
                fieldworkPageMutate(params);
            }}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: InvoicePageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WriteFieldwork/>}
                    }
                }
            }}
            code={"fieldwork"}
        />
    );
};
